module.exports = __webpack_public_path__ + "img/4_160.f51791e6.png";